import React from 'react'
import styled from 'styled-components'
import RcSlider from 'rc-slider'

const StyledSlider = styled(RcSlider.Range)`

`

export default class Slider extends React.PureComponent {
  render() {
    return <StyledSlider { ...this.props } />
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/Slider/Slider.js